export default __webpack_public_path__ + "static/media/Miscellaneous12.faca0e5d.jpg";